import { type FC } from "react";
import { Button } from "@root/shared/components/Button";
import { Icon } from "@root/shared/components/Icon";
import { LazyLoadImage } from "@root/shared/components/LazyLoadImage";
import * as styles from "./styles.css";

type Props = {
  fileRef: React.RefObject<HTMLInputElement>;
  handleUploadFile: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleClickButton: () => void;
};

export const Presentation: FC<Props> = ({ fileRef, handleUploadFile, handleClickButton }) => {
  return (
    <div className={styles.infoBox}>
      <div className={styles.uploadButtonContainer}>
        <div className={styles.imageUploadButton}>
          <Button
            onClick={handleClickButton}
            theme="secondary"
            leftIcon={<Icon name="add-more" />}
            size="large"
          >
            画像アップロード
          </Button>
        </div>
        <input
          type="file"
          accept=".png, .jpg, .jpeg"
          className={styles.hiddenInput}
          onChange={handleUploadFile}
          ref={fileRef}
          multiple
        />
      </div>
      <div className={styles.imageUploadInfo}>
        <ul className={styles.uploadImageText}>
          <li>
            <span className={styles.uploadImageTextBold}>推奨サイズ：</span>
            幅657 × 高さ370ピクセル以上
          </li>
          <li>
            <span className={styles.uploadImageTextBold}>掲載比率：</span>
            16:9
            <br />
            <small className={styles.uploadImageSmallText}>
              顔写真・スタッフプロフィール画像は1:1
            </small>
            <br />
            <small className={styles.uploadImageSmallText}>
              異なる比率の画像は自動でトリミングされます。
            </small>
          </li>
        </ul>
        <div className={styles.imageContainer}>
          <LazyLoadImage
            src="/images/client_frontend/imageSelectModal_figure_aboutImageSize.png"
            alt="画像比率の説明図"
            width={80}
            height={45}
          />
        </div>
        <p className={styles.uploadImageSmallText}>一度にアップロードできる画像は25枚までです。</p>
      </div>
      <div className={styles.dotListBox}>
        <p>以下の画像はアップロードできません。</p>
        <ul className={styles.dotList}>
          <li className={styles.dotListItem}>拡張子が「.png」「.jpg」「.jpeg」以外</li>
          <li className={styles.dotListItem}>20MB以上</li>
          <li className={styles.dotListItem}>幅460 × 高さ345ピクセル以下</li>
        </ul>
      </div>
    </div>
  );
};
